var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('TheLoader',{attrs:{"active":true}}):_c('div',{staticClass:"content-container flex-row"},[_c('section',{staticClass:"content white"},[_c('TheEmptyList',{attrs:{"title":'Ingen abonnement',"large":true,"icon":'glyph-medium-object'}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d17f1ce","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/KundeCardShowTabAbonnement.vue
// module id = null
// module chunks = 